// Utilities
import { defineStore } from 'pinia'
import { useLocalStorage, useSessionStorage } from '@vueuse/core'
import { rotasRestritas, rotasAbertas } from '../router/index'
import userStore from "./user"

export default defineStore('layout', {
  state: () => ({
    _railMenu: useSessionStorage('railMenu', false),
    _breadcrumbs: {},
    _loading: false,
    _loadingControle: false,
    _loadClass: "",
    _tempo: {},
    _wait: false,
    _sidebarOpen: false,

    _linksMenuObra: [] as any[],
    _linksMenuGeral: [] as any[],
    _linksMenuFabricacao: [] as any[],
    _executandoAcao: false,
    _msgCarregamento: "",
    _redirectTo: useLocalStorage('redirectTo',{})
  }),

  actions: {
    setBreadcrumbs(breadcrumbsP: any) {
      this._breadcrumbs = breadcrumbsP
    },
    setRail(rail: any) {
      this._railMenu = rail
      return this._railMenu;
    },
    // ESSE LOADING É O QUE ATIVA A ANIMAÇÃO DO LOGO, QUANDO USAR? NAÕ SEI
    setLoading(status: boolean) {
      
      const st = this;
      st._loadingControle = status;
      if (this._wait) {
        st._loadClass = "";
        return
      }

      this._wait = true;
      st._loadClass = "";
      st._loading = status;
      setTimeout(function () {
        st._wait = false;

        if (!st._loadClass) st._loadClass += " saindo";

        window.setTimeout(function () {
          st._loading = st._loadingControle;
          st._loadClass = "";
        }, 500);
      }, 4000);
    },

    filtrarRotasComAcesso() {
      const rotasRestritasObra = rotasRestritas.filter(rota => {
        if (rota.layoutNome == "LayoutObra") {
          return rota.children
        }
      })
      const rotasRestritasGerais = rotasRestritas.filter(rota => {
        if (rota.layoutNome == "LayoutGeral") {
          return rota.children
        }
      })
      const rotasAbertasGerais = rotasAbertas.filter(rota => {
        if (rota.layoutNome == "LayoutGeralAberto") {
          return rota.children
        }
      })
      const rotasRestritasFabricacao = rotasRestritas.filter(rota => {
        if (rota.layoutNome == "LayoutFabricacao") {
          return rota.children
        }
      })
      this._linksMenuFabricacao = separarPorGrupos([...filtraRota(rotasRestritasFabricacao)])
      this._linksMenuObra = separarPorGrupos([...filtraRota(rotasRestritasObra)])
      this._linksMenuGeral = separarPorGrupos([...filtraRota(rotasRestritasGerais), ...filtraRota(rotasAbertasGerais)])
    },

    setExecutando(status: boolean, msg: string = "") {
      const st = this;
      this._msgCarregamento = status ? msg : ""
      st._loadingControle = status;
      if (this._wait) {
        this._msgCarregamento = status ? msg : "Finalizando..."
        return
      }

      this._wait = true;
      st._executandoAcao = status;
      setTimeout(function () {
        st._wait = false;
        window.setTimeout(function () {
          st._executandoAcao = st._loadingControle;
        }, 500);
      }, 1000);
    },

    setMensagemCarregamento(msg: string) {
      this._msgCarregamento = msg
    },
    setRedirect(to: any) {
      this._redirectTo = to;
    },
    setSidebar(state: boolean) {
      this._sidebarOpen = state;
    }
  },

  getters: {
    breadcrumbs: (state) => {
      return state._breadcrumbs || []
    },
    loading: (state) => {
      return state._loading
    },
    loadClass: (state) => {
      return state._loadClass
    },
    railMenu: (state) => {
      return state._railMenu;
    },
    executandoAcao: (state) => {
      return state._executandoAcao;
    },
    msgCarregamento: (state) => {
      return state._msgCarregamento;
    },
    redirectTo: (state) => {
      return state._redirectTo;
    },
    isSidebarOpen: (state)=>{
      return state._sidebarOpen;
    }
  }

})

function filtraRota(todasRotas: any[], isRestrita = true) {
  let rotas: any[] = []
  todasRotas.forEach(rota => {
    if (rota['meta'].showMenu) {
      if (isRestrita) {
        if (possuiAcesso(userStore().ability, rota['meta'].subject, rota['meta'].action)) {
          rotas.push(rota)
        }
      } else {
        rotas.push(rota)
      }
    }
    if (rota.children) {
      rotas = rotas.concat(filtraRota(rota.children, isRestrita))
    }
  })
  return rotas
}

function separarPorGrupos(rotas: any[]) {
  let grupos: any = {}
  let items: any[] = []
  rotas.forEach((item: any) => {
    if (item.meta.showMenu) {
      if (item.meta.hasOwnProperty('grupo')) {
        if (grupos.hasOwnProperty(item.meta.grupo)) {
          grupos[item.meta.grupo].items.push(item)
        } else {
          grupos[item.meta.grupo] = {
            title: item.meta.grupoTitle,
            items: [item],
            eh_grupo: true
          }
        }
      } else {
        items.push({
          ...item,
          eh_grupo: false
        })
      }
    }
  })

  Object.keys(grupos).forEach(grupo => {
    items.push(grupos[grupo])
  })
  return items

}

function possuiAcesso(ability: any, rolesNecessarios: any, acoes = []) {
  if (ability) {
    if (rolesNecessarios && rolesNecessarios.length) {
      let liberado = false;
      let i = 0;
      do {
        if (acoes.length) {
          for (const acao of acoes) {
            liberado = ability.can(acao, rolesNecessarios[i])
          }
        } else {
          liberado = ability.can('read', rolesNecessarios[i])
        }
        i = i + 1
      } while (!liberado && i < rolesNecessarios.length)
      return liberado
    }
    return true
  }
  return false
}